import dayjs from "configs/dayjs";
import { DATE_TIME_FORMAT } from "constants/common/common";

export const formatCurrency = (amount: number): string =>
  amount.toLocaleString("vi-VN", { style: "currency", currency: "VND" });

export const formatDate = (timestamp: number): string =>
  timestamp ? dayjs(timestamp * 1000).format(DATE_TIME_FORMAT) : "—";

export const formatDateFormal = (timestamp: number): string => {
  const d = dayjs(timestamp * 1000);
  return `Ngày ${d.format("DD")} tháng ${d.format("MM")} năm ${d.format("YYYY")}`;
};

export const formatBankAccount = (name: string | null | undefined): string =>
  name ?? "Tiền mặt";
